import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useNewChipStyles } from './styles'

/**
 * "New" while a note is within WHATS_NEW_FRESH_DAYS. Text, not colour alone,
 * so it survives any tenant brand and every screen reader.
 */
export const NewChip = ({ dataTest = 'whats-new-new-chip', className = '' }) => {
  const classes = useNewChipStyles()
  return (
    <span className={clsx(classes.root, className)} data-test={dataTest}>
      New
    </span>
  )
}

NewChip.propTypes = {
  dataTest: PropTypes.string,
  className: PropTypes.string
}
